import { React } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import urls from "../../../../../config/urls";

function CourseLandingPageHeading({ title, subtitle }) {
  const navigate = useNavigate();

  const logo = "https://instituteofcatholicculture.net/wp-content/uploads/2022/11/icc-logo-2022-edited.png";

  const routeUser = () => {
    // implementing guard to prevent error if user double-clicks
    if (window.location.pathname.includes("/landing/")) {
      let slug = window.location.pathname.replace("/landing/", "");
      if (slug.endsWith("/")) {
        slug = slug.slice(0, -1);
      }
      navigate(`${urls.courseApplication}?slug=${slug}`);
    }
  }

  return (
    <div className="CourseLandingPage-heading container-content">
      <a href={urls.events}>
        <img src={logo} alt="Institute of Catholic Culture Logo" />
      </a>
      <div className="container-heading">
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
      </div>
      <Button variant="outlined" color="inherit" onClick={routeUser}>Apply Now</Button>
    </div>
  )
}

CourseLandingPageHeading.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default CourseLandingPageHeading;